// src/socket.js
import { io } from "socket.io-client";

const SOCKET_URL = "https://godoctor.cscodetech.cloud/";

export const socket = io(SOCKET_URL, {
  transports: ["websocket"],
});
